import Swiper, {Autoplay, Navigation} from "swiper";
import BaseSliderBlock from "./BaseSliderBlock";

class TextWithMedia extends BaseSliderBlock {

	init(): void {
		this.buildSlider();
	}

	buildSlider(): void {
		const sliderEl = this.block.querySelector(".col-media .swiper");
		if (sliderEl instanceof HTMLElement) {
			new Swiper(sliderEl, {
				loop: true,
				spaceBetween: 20,
				navigation: this.getDefaultNavigation(),
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true
				},
				modules: [Autoplay, Navigation]
			});
		}
	}
}

export default TextWithMedia;
